import type { FC, ReactChild } from 'react';
import React from 'react';

import type { RicosSchema } from './../ricos-orchestrator/ricos-schema.js';

export const SchemaContext = React.createContext<RicosSchema>(null as unknown as RicosSchema);

type SchemaContextProps = {
  schema: RicosSchema;
  children: ReactChild;
};

export const SchemaContextProvider: FC<SchemaContextProps> = ({ schema, children }) => (
  <SchemaContext.Provider value={schema}>{children}</SchemaContext.Provider>
);

export const SchemaContextConsumer = ({ children }: $TSFixMe) => (
  <SchemaContext.Consumer>{value => children(value)}</SchemaContext.Consumer>
);
